export default __webpack_public_path__ + "static/media/WhiteProfile.98ebc98d.svg";